import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Form,
  Table,
  Container,
  Row,
  Modal,
  Toast,
  Card,
  Button,
  Offcanvas,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useAlert } from "react-alert";
import api from "../../seller-apis/api";
import servicesApi from "../../seller-apis/servicesApi";
import { formatedDate } from "../../utilities/ConvertDateFormat";
import PaginationNew from "./Pagination";
import { variables } from "../../Variables.json";
import { fetchReviewsData } from '../../seller-apis/apidataField';
import convertFileToWebP from "../../utilities/convertFileToWebP";
import { GenUtilities } from "../../utilities/GenUtilities";
var filterData = {
  pageNo: 1,
  size: 12,
  filter: {
    // "type": "CUSTOMER"
    status: true
  },
  sortFilter: { "createdAt": -1 },
};
var currentLink;
function ProductReviews(props) {
  let alert = useAlert();
  const [selectedData, setSelectedData] = useState([]);
  const [totalrecords, setTotalRecords] = useState(0);
  const [selectedPage, setSelectedPage] = useState(1);
  const reviewsArr = [1, 2, 3, 4, 5];

  const [reviewPopShow, setReviewPopShow] = useState(false);
  const [selectedStar, setSelectedStar] = useState(null);
  const [sellerReview, setSellerReview] = useState(null);
  const [reviewImages, setReviewImages] = useState([]);
  const [reviewVideo, setReviewVideo] = useState(null);
  const [sellerReviewsCount, setSellerReviewsCount] = useState(0);
  const [showErr, setShowErr] = useState(false);
  const [imgprogress, setimgprogress] = useState();
  const [urlListshow, seturlListshow] = useState(false);
  const [vidurlListshow, setvidurlListshow] = useState(false);
  const [videoShow, setvideoShow] = useState("none");
  const [vendorId, setvendorId] = useState(localStorage.getItem("vendorId"));

  //  modal state
  // SL-1057
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mediaType, setMediaType] = useState("");
  const [mediaUrl, setMediaUrl] = useState("");

  useEffect(() => {
    if (props.from === "productDetails") {
      getRev();
    }
    getSellerRevCount(props.pId);
  }, [props.pId]);
  const getRev = (param = filterData) => {
    param.filter = {
      ...param.filter,
      "productId": props.pId,
    };
    api.Reviews.fetchReviewsByProduct(fetchReviewsData(param)).then(res => {
      res.data.forEach((obj) => {
        if (obj.createdAt) {
          let createdAtNew = new Date(obj.createdAt);
          createdAtNew = createdAtNew.toUTCString(obj.createdAt);
          obj.createdAtNew = createdAtNew.substr(4, 12);
        }
      });
      setSelectedData(res.data);
      setTotalRecords(res.totalRecords);
    });
  };

  const getSellerRevCount = (pId) => {
    const param = {
      pageNo: 1,
      size: 1,
      filter: {
        "productId": pId
      }
    };
    api.Reviews.fetchSellerReviewsByProduct(fetchReviewsData(param)).then(res => {
      setSellerReviewsCount(res.totalRecords);
    });
  };

  function closeReviewPop() {
    setReviewPopShow(false);
    setShowErr(false);
    setSelectedStar(null);
    setSellerReview(null);
  };

  // Show Image

  async function showImage(event) {
    console.log("hfh")
    let comImg;
    let imageFinal;
    let registerImage;
    let isimgsSizevalid = true;
    let limit = event.target.files.length;
    // for (let i = 0; i < limit; i++) {
    //   if (event.target.files[i].size > variables.limit.Newproductupload.image) {
    //     isimgsSizevalid = false;
    //   }
    // }
    // if (event.target.files[0].size < variables.limit.Newproductupload.image) {
    seturlListshow(false);
    let convertedImg = await convertFileToWebP(event.target.files[0]);
    var str = convertedImg.name;
    let extension = convertedImg.name.slice(
      convertedImg.name.lastIndexOf(".")
    );
    comImg = str.replace(/[^\w]/g, "");
    imageFinal = GenUtilities.removeSpacesFromName(props.pId + "_" + comImg + extension);
    registerImage = event.target.files[0];
    var data = {
      imageName: imageFinal,
    };
    const images = [...reviewImages, { image: imageFinal }]
    servicesApi
      .saveImage(data)
      .then((res) => {
        axios({
          method: "put",
          url: res.data,
          data: registerImage,
          onUploadProgress: (data) => {
            //Set the progress value to show the progress bar
            // setimgprogress(Math.round((100 * data.loaded) / data.total));
          },
        })
          .then((response) => {
            setimgprogress();
            seturlListshow(true);
            setReviewImages(images)
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((err) => console.log(err));
    // } else {
    //   alert.info("Please upload image of size less than or equal to 500 kb");
    // }
  }


  // Show Video

  async function showVideo(event) {
    console.log("hfh")
    console.log("event.target.files[0].size: ", event.target.files[0].size);
    let comImg;
    let imageFinal;
    let registerImage;
    let isimgsSizevalid = true;
    let limit = event.target.files.length;
    if (event.target.files[0].size < variables.limit.Newproductupload.video) {
      setvidurlListshow(false);
      var str = event.target.files[0].name;
      comImg = str.replace(0, str.lastIndexOf("."));
      imageFinal = GenUtilities.removeSpacesFromName(props.pId + "_" + comImg);
      registerImage = event.target.files[0];
      var data = {
        imageName: imageFinal,
        // type: "products",
      };

      servicesApi
        .saveImage(data)
        .then((res) => {
          axios({
            method: "put",
            url: res.data,
            data: registerImage,
            onUploadProgress: (data) => {
              //Set the progress value to show the progress bar
              setimgprogress(Math.round((100 * data.loaded) / data.total));
            },
          })
            .then((response) => {
              setimgprogress();
              setvidurlListshow(true);
              setReviewVideo(imageFinal);
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((err) => console.log(err));
    } else {
      alert.info("A max size of 15 Mb video can be uploaded");
    }
  }

  function getMediaUrl(key) {
    if (!key) return "";

    if (key.includes("imagedelivery")) {
      return normalizeUrl(key) + "/public";
    }

    if (key.includes("/reviews/")) {
      const reviewsIndex = key.indexOf("/reviews/");
      // return "https://s3.toolsvilla.com" + key.slice(reviewsIndex);
      return "https://s3.toolsvilla.com" + key.slice(reviewsIndex);
    }


    if (key.startsWith("http://") || key.startsWith("https://")) {
      return key;
    }

    return variables.imgUrl + "reviews/" + key;
  }

  function normalizeUrl(url) {
    const idx = url.indexOf("https://", 1);
    return idx !== -1 ? url.slice(idx) : url;
  }

  // play video
  function playVideo(vidId) {
    currentLink = vidId;
    setvideoShow("block");
    document.getElementById("cntn").classList.add("div-bk");
  }

  // Hide player
  function hidePlayer() {
    document.getElementById("vidPlayer").pause();
    document.getElementById("cntn").classList.remove("div-bk");
    setvideoShow("none");
  }

  // Delete image
  function deleteImg(index) {
    const newArray = [...reviewImages.slice(0, index), ...reviewImages.slice(index + 1)]
    console.log("reviewImages: ", reviewImages);
    // let eleLoader = document.getElementById("contain-Img-Pro-1"+index);
    setReviewImages(newArray);
    // console.log("reviewImages1122: ", reviewImages);
    // eleLoader.setAttribute("class", "spinner-border text-info");
  }

  // Delete video
  function deletevideo() {
    // setvidurlList([]);

    // videosName.splice(index, 1);
    let eleLoader = document.getElementById("loader-Vid-upload");
    setReviewVideo(null);
    eleLoader.setAttribute("class", "spinner-border text-info");

    setTimeout(() => {
      eleLoader.removeAttribute("class");
      setvidurlListshow(false);
    }, 1000);
  }

  function submitReview() {
    setShowErr(true);
    if (!selectedStar) {
      // alert.info("Rating is required");
      return false;
    } else if (!sellerReview || sellerReview === "") {
      // // alert.info("Review is required");
      return false;
    }
    const media = [...reviewImages, { video: reviewVideo }];
    const data = {
      ratings: selectedStar,
      productId: props.pId,
      review: sellerReview,
      media: media,
      order: {
        sku: props.pDetail.SKU,
        productName: props.pDetail.productName
      }
    }
    api.Reviews
      .reviewsCreate(data)
      .then((res) => {
        if (res.message == "Review Saved Successfully") {
          alert.success("Congratulations! Your review has been submitted for verification.");
          closeReviewPop();
          setSellerReviewsCount(sellerReviewsCount + 1);
          if (props.from === "activeProducts") {
            props.callback("product updated");
          }
        } else {
          alert.error("Failed to add review");
          closeReviewPop();
        }
      })
      .catch((err) => {
        console.log(err);
        alert.error("Failed to add review");
        closeReviewPop();
      });
  }

  function paginate(data) {
    filterData.pageNo = data.number;
    getRev(filterData);
    setSelectedPage(data.number);
  }

  // SL-1057
  function handleMediaClick(url, type) {
    setMediaUrl(url);
    setMediaType(type);
    setIsModalOpen(true);
  }

  return (
    <>
      <div className="mb-5 pb-4">
        {props.from === "productDetails" && (
          <>
            <div className={sellerReviewsCount === 0 ? "pd_long_desc mb-3 textReviews" : "pd_long_desc mb-3"}>
              <span>Reviews({totalrecords}): </span>
            </div>
            {/* {sellerReviewsCount === 0 &&
              <div className="add_pro_form_fin_btns btnWriteRev">
                <button onClick={() => setReviewPopShow(true)}><i className="fa fa-edit"></i> Write a review</button>
              </div>
            } */}
          </>
        )}
        {selectedData &&
          selectedData.map((review, index) => {
            return (
              <div key={index}>
                <div className='reviewBox'>
                  <p className="theme-col fs-12 f-700 mb-0">
                    <span className="text-blue">
                      {reviewsArr.map((rev) => (
                        rev <= review.ratings ?
                          <svg width="16" height="15" viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.0509 0L15.0833 2.89439L12.1653 11.6256L3.33009 11.5855L0.399811 11.571L2.73207 13.43L9.76098 19.0341L6.99328 27.8167L6.07632 30.7303L8.48526 28.9837L15.7473 23.7167L22.8728 29.186L25.2357 31L24.3924 28.0623L21.8501 19.2026L29.0216 13.7992L31.3998 12.0061L28.4711 11.9386L19.6374 11.7299L16.9448 2.92165L16.0509 0ZM15.9681 6.46775L17.9814 13.0543L10.9999 22L16.3437 23L18.9999 20.5L25.4979 13.9227L20.1373 17.9633L19.5684 18.3903L19.7708 19.0918L15.9681 18.286L16.3437 21.6266L15.7794 21.1931L15.2044 21.6105L20.9999 13.8178L14.1179 12.0061L6.25264 13.6532L12.8568 13.6837L19.7708 22L18.9999 13.2913L15.9681 6.46775Z" fill="#168A86" />
                          </svg> :
                          <svg width="16" height="15" viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.2509 0L15.2834 2.89439L12.3654 11.6256L3.53016 11.5855L0.599884 11.571L2.93214 13.43L9.96106 19.0341L7.19335 27.8167L6.2764 30.7303L8.68533 28.9837L15.9473 23.7167L23.0729 29.186L25.4358 31L24.5924 28.0623L22.0501 19.2026L29.2216 13.7992L31.5999 12.0061L28.6712 11.9386L19.8375 11.7299L17.1449 2.92165L16.2509 0ZM16.1681 6.46775L18.1815 13.0543L18.3946 13.7526L19.0938 13.7687L25.698 13.9227L20.3373 17.9633L19.7684 18.3903L19.9709 19.0918L21.8707 25.7153L16.5438 21.6266L15.9795 21.1931L15.4045 21.6105L9.97485 25.5484L12.0449 18.9811L12.2626 18.286L11.706 17.8414L6.45271 13.6532L13.0569 13.6837L13.7561 13.6869L13.9876 12.995L16.1681 6.46775Z" fill="#168A86" />
                          </svg>
                      ))}
                    </span>
                  </p>
                  <p className="fs-12 f-400 mb-0 revText">
                    {review.review}
                  </p>
                  <div className="review_media_box">
                    {review.media &&
                      review.media.map((item, ind) => {
                        if (item?.image) {
                          return (
                            item.image !== undefined && item.image !== null &&
                            <div key={"revItem" + ind} className="review_media_item">
                              <img
                                src={getMediaUrl(item.image)}
                                alt="img"
                                onClick={()=>handleMediaClick(getMediaUrl(item.image), 'image')}
                              />
                            </div>
                          )
                        } else if (item?.video) {
                          return (
                            item.video !== undefined && item.video !== null &&
                            <div key={"revItem" + ind} className="review_media_item"  onClick={()=>handleMediaClick(getMediaUrl(item?.video), 'video')}>
                              <video
                                src={getMediaUrl(item?.video)}
                                alt="video"
                              />
                              <i className="bi bi-play-circle-fill review_media_video_play_icon"></i>
                            </div>
                          )
                        }
                      })
                    }
                  </div>
                  <p className="fs-12 f-400 mb-0 revFooter">
                    {review.type === "TOOLSVILLA" && (
                      <span>Toolsvilla Verified</span>
                    )}

                    {review.type === "SELLER" && (
                      review.vendorId === vendorId ?
                        <span>Review by You</span> :
                        <span>Seller Verified</span>
                    )}
                    {review.type === "CUSTOMER" && (
                      <>
                        <div className="customerRev">
                          {review.nickName && <span>{review.nickName}</span>}
                          <span><img src="/verified-user-icon.png" className="verfIcon" alt="icon" /> Verified purchase on :</span>
                          <span>{review.createdAtNew}</span>
                        </div>
                      </>
                    )}
                  </p>
                </div>
                <div className="bottom-border"></div>
              </div>
            );
          })}
        <div className="hide-pagi-title">
          <PaginationNew
            number={totalrecords}
            paginate={paginate}
            activ={selectedPage}
            perPage={12}
            comp={"quesAnsList"}
          />
        </div>
        {props.from !== "productDetails" && sellerReviewsCount === 0 &&
          <div className="add_pro_form_fin_btns btnWriteRev btnWriteRevProdList">
            <button onClick={() => setReviewPopShow(true)}><i className="fa fa-edit"></i> Write a review</button>
          </div>
        }
      </div>

      {/* Off canvas for seller review */}

      <Offcanvas
        show={reviewPopShow}
        onHide={() => closeReviewPop()}
        placement="bottom"
        className="h-60 pd_Offcanvas m-auto "
        backdrop="static"
      >
        <Offcanvas.Header>
          <Offcanvas.Title></Offcanvas.Title>
          <button
            className="pd_my_Modal_close_btn"
            onClick={() => closeReviewPop()}
          >
            X
          </button>
        </Offcanvas.Header>
        <Offcanvas.Body className="m-0 p-0">
          <Container className="pd_offcanvas_body">
            <div className="pd_Offcanvas_Action" id="cntn">

              <div className="pd_Offcanvas_Grey_Box">
                <p className="iscorr_trans_p row">
                  <span className="col-5">
                    Your rating on product quality:
                  </span>
                  <span className="col-6 reviewStar">
                    {[1, 2, 3, 4, 5].map((item, index) => {
                      if (index < selectedStar) {
                        // return <i class="fa fa-star" key={`rating${index}`} onClick={() => setSelectedStar(item)}></i>;
                        return <i key={`rating${index}`} onClick={() => setSelectedStar(item)}>
                          <svg width="16" height="15" viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.0509 0L15.0833 2.89439L12.1653 11.6256L3.33009 11.5855L0.399811 11.571L2.73207 13.43L9.76098 19.0341L6.99328 27.8167L6.07632 30.7303L8.48526 28.9837L15.7473 23.7167L22.8728 29.186L25.2357 31L24.3924 28.0623L21.8501 19.2026L29.0216 13.7992L31.3998 12.0061L28.4711 11.9386L19.6374 11.7299L16.9448 2.92165L16.0509 0ZM15.9681 6.46775L17.9814 13.0543L10.9999 22L16.3437 23L18.9999 20.5L25.4979 13.9227L20.1373 17.9633L19.5684 18.3903L19.7708 19.0918L15.9681 18.286L16.3437 21.6266L15.7794 21.1931L15.2044 21.6105L20.9999 13.8178L14.1179 12.0061L6.25264 13.6532L12.8568 13.6837L19.7708 22L18.9999 13.2913L15.9681 6.46775Z" fill="#168A86" />
                          </svg>
                        </i>
                      } else {
                        // return <i class="fa fa-star gry" key={`rating${index}`} onClick={() => setSelectedStar(item)}></i>;
                        return <i key={`rating${index}`} onClick={() => setSelectedStar(item)}>
                          <svg width="16" height="15" viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.2509 0L15.2834 2.89439L12.3654 11.6256L3.53016 11.5855L0.599884 11.571L2.93214 13.43L9.96106 19.0341L7.19335 27.8167L6.2764 30.7303L8.68533 28.9837L15.9473 23.7167L23.0729 29.186L25.4358 31L24.5924 28.0623L22.0501 19.2026L29.2216 13.7992L31.5999 12.0061L28.6712 11.9386L19.8375 11.7299L17.1449 2.92165L16.2509 0ZM16.1681 6.46775L18.1815 13.0543L18.3946 13.7526L19.0938 13.7687L25.698 13.9227L20.3373 17.9633L19.7684 18.3903L19.9709 19.0918L21.8707 25.7153L16.5438 21.6266L15.9795 21.1931L15.4045 21.6105L9.97485 25.5484L12.0449 18.9811L12.2626 18.286L11.706 17.8414L6.45271 13.6532L13.0569 13.6837L13.7561 13.6869L13.9876 12.995L16.1681 6.46775Z" fill="#168A86" />
                          </svg>
                        </i>
                      }
                    })}
                  </span>
                  {showErr && !selectedStar &&
                    <span className="clrRed">Rating is required*</span>
                  }
                </p>
                <p className="iscorr_trans_p row">
                  <span className="col-12">
                    Write a review*:
                  </span>
                </p>
                <div className="iscorr_trans_p row">
                  <div className="col-12">
                    <textarea
                      rows="2"
                      className="writeReview"
                      onChange={(e) => setSellerReview(e.target.value)}
                      onWheel={(e) => e.target.blur()}
                    ></textarea>
                    {showErr && (!sellerReview || sellerReview === "") &&
                      <span className="clrRed">Review is required*</span>
                    }
                  </div>
                </div>
                <div className="iscorr_trans_p row">
                  <span className="col-12">
                    Upload photos and videos
                  </span>
                </div>
                <div className="iscorr_trans_p row">
                  {urlListshow === true ?
                    reviewImages.map((item, index) => {
                      return (
                        <>
                          <div className="col-2">
                            <div className="text-center">
                              <div className="add_pro_form_image_cntn imgBox">
                                <img
                                  src={
                                    "https://s3.toolsvilla.com/reviews/" +
                                    item.image
                                  }
                                  className="add_pro_form_image_file vid-P"
                                  alt="img"
                                  id={"contain-Img-Pro-1" + index}
                                />
                                <i
                                  className="bi bi-trash fs-14 add_pro_form_med_del_btn_img"
                                  onClick={() => deleteImg(index)}
                                ></i>

                              </div>
                            </div>
                          </div>
                        </>
                      )
                    }) : (
                      <></>
                    )}
                  <div className="col-2">
                    <div className="text-center">
                      <div className="add_pro_form_image_cntn imgBox">
                        <label
                          for={"imgUploadImg_1"}
                          id="uploadIcon"
                          className="add_pro_form_label"
                        >
                          <img src="/ImageAdd.png" alt="Add image" />
                        </label>
                      </div>
                      <input
                        type="file"
                        id="imgUploadImg_1"
                        className="add_pro_form_uploadFile"
                        onChange={(event) => showImage(event)}
                        onClick={(e) => (e.target.value = null)}
                        accept="image/*"
                      />
                    </div>
                  </div>

                  {/* Add video */}
                  <div className="col-2">
                    <div className="text-center">
                      {/* {progress && (
                          <ProgressBar
                            id="progress-B"
                            className="add_pro_form_progressbar"
                            now={progress}
                            label={`${progress}%`}
                          />
                        )} */}
                      <div className="add_pro_form_image_cntn imgBox">
                        <label
                          for="uploadFile2"
                          id="uploadIcon"
                          className="add_pro_form_label"
                        >
                          <img src="/video_icon.png" alt="Add video" />
                        </label>
                        {vidurlListshow === true ? (
                          <>
                            <video
                              src={
                                "https://s3.toolsvilla.com/reviews/" +
                                reviewVideo
                              }
                              className="add_pro_form_video_file vid-P"
                              // onClick={() =>
                              //   playVideo(
                              //     "https://s3.toolsvilla.com/reviews/" +
                              //     reviewVideo
                              //   )
                              // }
                              // key={1}
                              alt="img"
                              id="loader-Vid-upload"
                              controls
                            />
                            <i
                              className="bi bi-x-square-fill fs-14 text-yellow add_pro_form_med_del_btn"
                              onClick={() => deletevideo()}
                            ></i>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                      <input
                        type="file"
                        id="uploadFile2"
                        className="add_pro_form_uploadFile"
                        onChange={(event) => showVideo(event)}
                        accept="video/*"
                        value=""
                      // disabled={
                      //   utubevideo === undefined || utubevideo === ""
                      //     ? false
                      //     : true
                      // }
                      />
                    </div>
                  </div>

                </div>

              </div>
              <div className="submitReviewWrap">
                <button
                  className="submitReview"
                  onClick={() => submitReview()}
                >
                  SUBMIT REVIEW
                </button>
              </div>

            </div>
          </Container>
        </Offcanvas.Body>
      </Offcanvas>

      {/* SL-1057 */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            {mediaType === "image" ? (
              <img src={mediaUrl} alt="Modal Content" className="modal-image" />
            ) : (
              <video src={mediaUrl} controls className="modal-video" />
            )}
            <button className="close-modal" onClick={() => setIsModalOpen(false)}>
              ×
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default ProductReviews;